
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiElectricGeneratorOrMotorAc as ObiElectricGeneratorOrMotorAcElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-electric-generator-or-motor-ac.js';
 
 
 

 
 export const ObiElectricGeneratorOrMotorAc = createComponent({
   react: React,
   tagName: 'obi-electric-generator-or-motor-ac',
   elementClass: ObiElectricGeneratorOrMotorAcElement,
   events: {
     
   }
  });
 
 